import React from 'react';

export default function Documentation() {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh', background: '#fff' }}>
      <h2 className="mb-4" style={{ fontWeight: 700, color: '#222' }}>API Documentation</h2>
      <a
        href="https://documenter.getpostman.com/view/46662670/2sB34kEJy8"
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-primary px-4 py-2 fw-bold"
        style={{ fontSize: '1.15rem', borderRadius: 8 }}
      >
        View API Docs on Postman
      </a>
      <p className="mt-3 text-muted" style={{ fontSize: '1rem' }}>
        Click the button above to view the latest API documentation.
      </p>
    </div>
  );
}
